import Syllables from './Syllables';

export default Syllables;
